<template>
	<div class="el-col-sm-24">
		<md-switch v-if="canBuyTci || canOnlyViewTci" style="margin: 5px" class="text_right"
				   v-model="params.data[params.colDef.field]"
				   :disabled="canOnlyViewTci || !isInsuranceAllowed">
		</md-switch>
		<span v-else>
      		{{ this.$t("common.value.hidden") }}
    	</span>
	</div>
</template>

<script>

export default {
	computed: {
		useInsurance() {
			return this.params.data[this.params.colDef.field];
		},
		canBuyTci() {
			return this.params.canBuyTci;
		},
		canOnlyViewTci() {
			return this.params.canOnlyViewTci;
		},
		isInsuranceAllowed() {
		  	return !this.params.data[this.params.isInsuranceDisabledField];
		},
	},
	methods: {
		checkIfChangedIsAllowed() {
			// Do not allow setting this to true by e.g. the all switch
			if (this.useInsurance && (!this.canBuyTci || !this.isInsuranceAllowed)) {
				this.params.data[this.params.colDef.field] = false;
			}
		}
	},
	watch: {
		useInsurance() {
			this.checkIfChangedIsAllowed();
			this.params.onChange(this.params);
		}
	}

};
</script>